export function formatTimesForHHMM(time: string): string {
  if (typeof time !== "string") return "Invalid Time";

  const parts = time.split(":");
  if (parts.length < 2) return "Invalid Time";

  const [hours, minutes] = parts;
  if (isNaN(Number(hours)) || isNaN(Number(minutes)) || Number(hours) < 0 || Number(hours) > 23 || Number(minutes) < 0 || Number(minutes) > 59) {
    return "Invalid Time";
  }

  return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
}
